import { Box, Typography } from "@mui/material";
import { ContestWithId } from "../../interfaces/IContests";
import { formatDate } from "../../utils/dates";

interface ContestDatesSectionProps {
  contest?: ContestWithId;
  label?: string;
}

export default function ContestDatesSection({
  contest,
  label = "Termin:",
}: ContestDatesSectionProps) {
  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
      <Typography variant="body2" color="text.secondary" sx={{ fontSize: "0.8rem" }}>
        {label}
      </Typography>
      <Typography variant="body2" sx={{ fontWeight: 500, fontSize: "0.8rem" }}>
        {contest?.startDate && contest?.endDate
          ? `${formatDate(contest.startDate)} - ${formatDate(contest.endDate)}`
          : "Brak"}
      </Typography>
    </Box>
  );
}
